<div class="card">
    <div class="header">
        <h2>Unique Admission</h2>
    </div>
    <div class="body">
        <div id="chart">
            <apx-chart [series]="pieChartOptions.series2!" [chart]="pieChartOptions.chart!"
                       [labels]="pieChartOptions.labels!" [responsive]="pieChartOptions.responsive!"
                       [dataLabels]="pieChartOptions.dataLabels!" [legend]="pieChartOptions.legend!" class="apex-pie-center">
            </apx-chart>
        </div>
        <div class="table-responsive m-t-15">
            <table class="table align-items-center">
                <tbody>
                <tr>
                    <td><i class="fa fa-circle col-blue msr-2"></i>Total Unique Admissions</td>

                    <td class="col-blue">{{totalRegisteredChildren}}</td>
                </tr>
                <tr>
                    <td><i class="fa fa-circle col-green msr-2"></i>Total Boys</td>
                    <td class="col-green">{{totalRegisteredBoys}}</td>
                </tr>
                <tr>
                    <td><i class="fa fa-circle col-orange msr-2"></i>Total Girls</td>
                    <td class="col-orange">{{totalRegisteredGirls}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
